import React, { useEffect, useState } from 'react'
import { AnalyzerDropdown } from '../components/AnalyzerDropdown'
import { getAllUsers, User } from '../../../../services/endpoints/user'
import useAsyncService from '../../../../hooks/useAsyncService'

const UserSelectorWrapper = () => {
  const [users, setUsers] = useState<User[]>([])

  const { serviceValue, serviceError, setServiceArgs } = useAsyncService<
    void,
    User[]
  >({
    serviceCall: getAllUsers,
    delay: 0,
    initialArgs: null
  })

  useEffect(() => {
    setServiceArgs()
  }, [setServiceArgs])

  useEffect(() => {
    if (serviceValue) {
      setUsers(serviceValue)
    }
  }, [serviceValue, serviceError])

  const options = [
    { label: 'None', value: '' },
    ...users.map((u) => ({
      label: u.username,
      value: u.id.toString()
    }))
  ]

  return (
    <AnalyzerDropdown
      name="scriptExecUser"
      label="Execute Script As"
      options={options}
    />
  )
}

export default UserSelectorWrapper
